import { forwardRef } from "react"
import { useSwiper } from 'swiper/react'

/* Protopia Ecosystem component */
export interface IPrevButtonProps {
    onClick: (i: number) => void  
    to: number
}
const To = forwardRef((props: IPrevButtonProps, ref:any): JSX.Element => { 
    const swiper = useSwiper()
    const onClick = () => { 
        swiper.slideTo( props.to )
        props.onClick( props.to )
    }
    return <div className='position-absolute unvisibled' onClick={onClick} ref={ref} />
})
export default To 